class DialogModal extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-modal-close]')) this.close();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !this.hidden) this.close();
    });
  }

  open() {
    this.hidden = false;
    document.body.classList.add('modal-open');
    this.offsetHeight;
    this.classList.add('is-open');
  }

  close() {
    this.classList.remove('is-open');
    document.body.classList.remove('modal-open');
    const finish = () => {
      this.hidden = true;
    };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      finish();
    } else {
      this.addEventListener('transitionend', finish, { once: true });
    }
  }
}

customElements.define('dialog-modal', DialogModal);
